const Buttonİsim = [
    "horoscope",
    "daily",
    "tarot",
    "article",
    "contact"
  ,]
  export default Buttonİsim;